import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Myaccount.css"
import {BASE_URL} from "./Constants";

const MyAccount = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const res = await fetch(`${BASE_URL}/get_user_details`, {
          method: "GET",
          credentials: "include", // cookie sent automatically
          headers: {
              "Content-Type": "application/json"
          }
        });
        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.error ||"Unauthorized");
        setUserData(data);
      } catch {
        navigate("/checkout/login");
      }
    };
    fetchUserDetails();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await fetch(`${BASE_URL}/logout`, {
        method: "GET",
         credentials: "include"
       });
      alert("Logged out successfully");
      navigate("/checkout/login");
    } catch {
      alert("Error logging out");
    }
  };

  if (!userData) return <div>Loading...</div>;

  return (
    <>
      <div className="myaccount-container">
        <h2>My Account</h2>
        <p><strong>User ID:</strong> {userData.user_id}</p>
        <p><strong>Email:</strong> {userData.email}</p>
        <button onClick={handleLogout}>Logout</button>
      </div>
    </>
  );
};

export default MyAccount;